import React from "react";
import { commitMutation, graphql } from "react-relay";
import { type RouteComponentProps, withRouter } from "react-router-dom";

import { BillingIdentity } from "~/billing";
import ThemeContext from "~/common/ThemeContext";
import { smart } from "~/lib/relayUtil";
import { environment } from "~/models";
import { Button } from "~/ui";
import toast from "~/ui/toast";

import { ReactComponent as Illo, ReactComponent as IlloDark } from "./css/thumb-illo.svg";

import type { NotFound_viewer$data as Viewer } from "~/__generated__/NotFound_viewer.graphql";
import type { NotFoundCreateDraftMutation as CreateMutation } from "~/__generated__/NotFoundCreateDraftMutation.graphql";

import styles from "./css/NotFound.module.css";

const CreateDraftMutation = graphql`
	mutation NotFoundCreateDraftMutation($type: Type!) {
		createDraftFeedback(type: $type) {
			feedback {
				id
			}
		}
	}
`;

type NotFoundProps = RouteComponentProps & {
	viewer: Viewer;
};

export default withRouter(
	smart(
		class NotFound extends React.Component<NotFoundProps> {
			static contextType = ThemeContext;
			declare context: React.ContextType<typeof ThemeContext>;

			static Fragments = {
				viewer: graphql`
					fragment NotFound_viewer on Viewer {
						...BillingIdentityFeaturesPaywall_viewer
					}
				`,
			};
			startNewFeedback = () => {
				commitMutation<CreateMutation>(environment, {
					mutation: CreateDraftMutation,
					variables: {
						type: "REQUESTED",
					},
					onCompleted: ({ createDraftFeedback }, errors) => {
						if (errors) toast.error(`Could not start new feedback: ${errors[0].message}`);
						if (createDraftFeedback) {
							const {
								feedback: { id },
							} = createDraftFeedback;

							this.props.history.push(`/feedback/${id}/draft/`);
						}
					},
				});
			};

			render() {
				return (
					<div className={styles.emptyState}>
						{this.context.isDarkMode ? <IlloDark /> : <Illo />}
						<h5>You do not have access to this feedback, or it is no longer available</h5>
						<BillingIdentity feature="feedback" deprecated viewer={this.props.viewer} iconInheritColor>
							{(extraProps, icon, paywalled) => (
								<Button
									size="wide"
									variant={paywalled ? "billing" : "primary"}
									onClick={this.startNewFeedback}
									{...extraProps}
								>
									Start new feedback
								</Button>
							)}
						</BillingIdentity>
					</div>
				);
			}
		},
	),
);
